import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ServicesSection from "./ServicesSection";
import Newsection from "./Newsection";
import Testimonials from "./Testimonials";
import { motion } from "framer-motion";
import '../styles/Hero.css'
import Google from "../images/Logo-Google-Cloud.png";
import Slack from "../images/openstack-logo.png";
import Heroku from "../images/aws_logo.png";
import Agworld from "../images/heroku_logo.png";
import Riotinto from "../images/digital_ocean_logo.png";
import HeoVideo from '../images/Firefly Start → Abstract tech animation (2 sec)__Cut → Team working in office__Cut → Interview - hir.mp4';
// import HeoVideo from '../images/hero.mp4';
import ITStaffing from '../images/services/it-staff.jpg';
import Training from '../images/services/training-program.jpg';
import Career from '../images/services/career-dev.jpg';
import Cloud from '../images/services/cloud-solutions.jpg'

const brands = [Google, Slack, Heroku, Agworld, Riotinto];
const Hero = () => {
  const navigate = useNavigate();
  const sentence = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.045,   // typing speed
        delayChildren: 0.4        // delay before typing starts
      }
    }
  };

  const line1 = "EMPOWERING BUSINESSES WITH";
  const line2 = "GLOBAL TALENT & TECHNOLOGY";

  const STAGGER = 0.045;   // typing speed per character
  const START_DELAY = 0.6; // delay before typing begins

  const container = (delay = 0) => ({
    hidden: {},
    show: {
      transition: {
        delayChildren: delay,
        staggerChildren: STAGGER
      }
    }
  });

  const letter = {
    hidden: { opacity: 0, y: 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.18, ease: "easeOut" }
    }
  };

  const cursor = {
    blink: {
      opacity: [0, 1, 0],
      transition: { duration: 1, repeat: Infinity }
    }
  };
  const line1Duration = line1.length * STAGGER + START_DELAY + 0.3;

  const containerAnim = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.15 }
    }
  };

  const itemAnim = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  const typingReveal = {
    hidden: { clipPath: "inset(0 100% 0 0)" },
    show: {
      clipPath: "inset(0 0% 0 0)",
      transition: { duration: 1.4, ease: "easeOut", delay: 0.4 }
    }
  };

  const TypeLine = ({ text, className = "", delay = 0 }) => (
    <motion.span
      className={className}
      variants={sentence}
      initial="hidden"
      animate="show"
      transition={{ delay }}
      style={{ display: "block", whiteSpace: "nowrap" }}
    >
      {text.split("").map((char, i) => (
        <motion.span key={i} variants={letter}>
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
    </motion.span>
  );

  // Cards Service
  const containerVariant = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18
      }
    }
  };

  const cardVariant = {
    hidden: { opacity: 0, y: 60, scale: 0.9 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  // Header animation
  const headerContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2
      }
    }
  };

  const headerItem = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1] // smooth premium easing
      }
    }
  };

  /* left image */
  const imageAnim = {
    hidden: { opacity: 0, x: -80, scale: 0.95 },
    show: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  /* right content */
  const contentAnim = {
    hidden: { opacity: 0, x: 80 },
    show: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };


  /* progress bar animation */
  const progressAnim = (value) => ({
    hidden: { width: 0 },
    show: {
      width: value,
      transition: { duration: 1.4, ease: "easeOut" }
    }
  });


  return (
    <main className="hero-page-wrapper">
      {/* SECTION 1: MAIN HERO AREA */}
      <section className="hero-container">
        {/* <div
          className="hero-background"
          style={{ backgroundImage: "url('/images/5114443_Workteam_Working_Team_1280x720.mp4')" }}
        ></div> */}

        <div className="hero-background">

          <video
            autoPlay
            muted
            loop
            playsInline
            className="hero-video"
          >
            <source
              src={HeoVideo}
              type="video/mp4"
            />
          </video>

          <div className="hero-white-overlay"></div>

        </div>

        <div className="container h-100">
          <div className="row align-items-center h-100">
            <div className="col-lg-7 col-md-9 col-12">

              <motion.div
                className="hero-content"
                variants={containerAnim}
                initial="hidden"
                animate="show"
              >

                {/* <motion.div className="new-badge" variants={itemAnim}>
                  <span className="badge-tag">
                    <span className="sparkle">✨</span> NEW
                  </span>
                  CLOUD SOLUTIONS
                </motion.div> */}

                <motion.h1
                  className="hero-title"
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.6 }}
                >
                  <motion.div variants={container(START_DELAY)} className="text-white d-block">
                    {"TAILORED IT STAFFING,".split(" ").map((word, i) => (
                      <span key={i} style={{ display: "inline-block", marginRight: "12px" }}>
                        {word.split("").map((char, j) => (
                          <motion.span key={j} variants={letter} style={{ display: "inline-block" }}>
                            {char}
                          </motion.span>
                        ))}
                      </span>
                    ))}
                  </motion.div>

                  <motion.div variants={container(line1Duration)} className="text-white d-block">
                    {"TRAINING &".split(" ").map((word, i) => (
                      <span key={i} style={{ display: "inline-block", marginRight: "12px" }}>
                        {word.split("").map((char, j) => (
                          <motion.span key={j} variants={letter} style={{ display: "inline-block" }}>
                            {char}
                          </motion.span>
                        ))}
                      </span>
                    ))}

                    <span className="purple-highlight">
                      {"CAREER DEVELOPMENT SOLUTIONS".split(" ").map((word, i) => (
                        <span key={i} style={{ display: "inline-block", marginRight: "12px" }}>
                          {word.split("").map((char, j) => (
                            <motion.span key={j} variants={letter} style={{ display: "inline-block" }}>
                              {char}
                            </motion.span>
                          ))}
                        </span>
                      ))}
                    </span>
                  </motion.div>
                </motion.h1>

                <motion.button
                  className="talk-btn"
                  variants={itemAnim}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  onClick={() => navigate("/contact")}
                >
                  GET STARTED <span className="ms-2">→</span>
                </motion.button>

                {/* Social Proof */}
                <motion.div className="social-proof" variants={itemAnim}>
                  <div className="avatars">
                    <div className="avatar" style={{ backgroundImage: 'url("https://i.pravatar.cc/60?img=32")' }}></div>
                    <div className="avatar" style={{ backgroundImage: 'url("https://i.pravatar.cc/60?img=45")' }}></div>
                    <div className="avatar" style={{ backgroundImage: 'url("https://i.pravatar.cc/100?img=3")' }}></div>
                  </div>

                  <div className="text-white">
                    <div className="count">10K+</div>
                  </div>
                </motion.div>
                <div className="sub mt-2 text-white"><span className='text-sucess'>●</span> 10,000+ PEOPLE ALREADY JOINED THE HERD.</div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Floating Slider Dock */}
        <div className="slider-dock-container d-md-block d-none">
          <div className="dock-curve-left"></div>
          <div className="slider-main-tab">
            <span className="arrow-btn">←</span>
            <div className="slider-inner-pill">
              <span className="loading-ring"></span>
              STRATEGIC PLANNING
            </div>
            <span className="arrow-btn">→</span>
          </div>
        </div>
      </section>


      {/* SECTION 2: PARTNERS BAR */}

      <div className="brand-wrapper py-4 container">
        <h5 className="fw-bold text-center mb-5">FEATURED PARTNERS CLICK A LOGO TO SEE THEIR FEEDBACK ON MSP PROCESS</h5>
        <motion.div
          className="brand-track"
          animate={{ x: [0, "-50%"] }}
          transition={{
            duration: 20,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {[...brands, ...brands].map((logo, i) => (
            <div key={i} className="brand-item">
              <img src={logo} alt="brand" />
            </div>
          ))}
        </motion.div>
      </div>

      {/* SECTION 3: TAILORED SOLUTIONS (SERVICES) */}
      <section className="container py-4">
        {/* Header */}
        <motion.div
          className="solutions-header mb-5"
          variants={headerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
        >

          <motion.h2 variants={headerItem} className="testmonial-badge" style={{ display: 'inline-block' }}>
            WHAT WE OFFER
          </motion.h2>

          <motion.h2 variants={headerItem} className="section-title">
            TAILORED IT SOLUTIONS: <br />
            <span className="purple-text">IT STAFFING, TRAINING & CAREER DEVELOPMENT</span>
          </motion.h2>

          <motion.p variants={headerItem} className="section-subtitle">
            Fortune Cloud Solutions provides tailored IT staffing,
            industry-relevant training, and career development services,
            empowering businesses and professionals to thrive in the
            ever-evolving IT landscape.
          </motion.p>
        </motion.div>

        {/* SERVICES */}
        <motion.div
          className="services-wrapper"
          variants={containerVariant}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "80px" }}
        >

          {/* DESKTOP GRID */}
          <div className="row d-none d-lg-flex mt-0">

            {/* CARD 1 */}
            <motion.div className="col-lg-3" variants={cardVariant}>
              <div className="service-card h-100 clickable-card" onClick={() => navigate("/services/it-staffing")}>

                <div className="service-image">
                  <img src={ITStaffing} alt="IT Staffing" />
                </div>

                <h3>IT STAFFING</h3>
                <div className="card-separator"></div>

                <p>
                  Connecting organizations with skilled IT professionals to meet project and business needs.
                </p>

                <Link to="/services/it-staffing" className="learn-more-btn">
                  EXPLORE SERVICE →
                </Link>

              </div>
            </motion.div>

            {/* CARD 2 */}
            <motion.div className="col-lg-3" variants={cardVariant}>
              <div className="service-card h-100 clickable-card" onClick={() => navigate("/services/training-programs")}>

                <div className="service-image">
                  <img src={Training} alt="Training Programs" />
                </div>

                <h3>TRAINING PROGRAMS</h3>
                <div className="card-separator"></div>

                <p>
                  Providing industry-relevant training to enhance IT workforce readiness.
                </p>

                <Link to="/services/training-programs" className="learn-more-btn">
                  EXPLORE SERVICE →
                </Link>

              </div>
            </motion.div>

            {/* CARD 3 */}
            <motion.div className="col-lg-3" variants={cardVariant}>
              <div className="service-card h-100 clickable-card" onClick={() => navigate("/services/career-development")}>

                <div className="service-image">
                  <img src={Career} alt="Career Development" />
                </div>

                <h3>CAREER DEVELOPMENT</h3>
                <div className="card-separator"></div>

                <p>
                  Guiding individuals to achieve their career goals in the IT industry.
                </p>

                <Link to="/services/career-development" className="learn-more-btn">
                  EXPLORE SERVICE →
                </Link>

              </div>
            </motion.div>

            {/* CARD 4 */}
            <motion.div className="col-lg-3" variants={cardVariant}>
              <div className="service-card h-100 clickable-card" onClick={() => navigate("/services/cloud-solutions")}>

                <div className="service-image">
                  <img src={Cloud} alt="Cloud Solutions" />
                </div>

                <h3>CLOUD SOLUTIONS</h3>
                <div className="card-separator"></div>

                <p>
                  Delivering scalable cloud infrastructure and migration solutions for modern businesses.
                </p>

                <Link to="/services/cloud-solutions" className="learn-more-btn">
                  EXPLORE SERVICE →
                </Link>

              </div>
            </motion.div>

          </div>


          {/* MOBILE + TABLET SWIPER */}
          <div className="d-lg-none">

            <Swiper
              modules={[Navigation]}
              navigation
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 }
              }}
            >

              <SwiperSlide>
                <div className="service-card clickable-card" onClick={() => navigate("/services/it-staffing")}>
                  <div className="service-image">
                    <img src={ITStaffing} alt="IT Staffing" />
                  </div>

                  <h3>IT STAFFING</h3>
                  <div className="card-separator"></div>

                  <p>
                    Connecting organizations with skilled IT professionals to meet project and business needs.
                  </p>

                  <Link to="/services/it-staffing" className="learn-more-btn">
                    EXPLORE SERVICE →
                  </Link>
                </div>
              </SwiperSlide>


              <SwiperSlide>
                <div className="service-card clickable-card" onClick={() => navigate("/services/training-programs")}>
                  <div className="service-image">
                    <img src={Training} alt="Training Programs" />
                  </div>

                  <h3>TRAINING PROGRAMS</h3>
                  <div className="card-separator"></div>

                  <p>
                    Providing industry-relevant training to enhance IT workforce readiness.
                  </p>

                  <Link to="/services/training-programs" className="learn-more-btn">
                    EXPLORE SERVICE →
                  </Link>
                </div>
              </SwiperSlide>


              <SwiperSlide>
                <div className="service-card clickable-card" onClick={() => navigate("/services/career-development")}>
                  <div className="service-image">
                    <img src={Career} alt="Career Development" />
                  </div>

                  <h3>CAREER DEVELOPMENT</h3>
                  <div className="card-separator"></div>

                  <p>
                    Guiding individuals to achieve their career goals in the IT industry.
                  </p>

                  <Link to="/services/career-development" className="learn-more-btn">
                    EXPLORE SERVICE →
                  </Link>
                </div>
              </SwiperSlide>


              <SwiperSlide>
                <div className="service-card clickable-card" onClick={() => navigate("/services/cloud-solutions")}>
                  <div className="service-image">
                    <img src={Cloud} alt="Cloud Solutions" />
                  </div>

                  <h3>CLOUD SOLUTIONS</h3>
                  <div className="card-separator"></div>

                  <p>
                    Delivering scalable cloud infrastructure and migration solutions for modern businesses.
                  </p>

                  <Link to="/services/cloud-solutions" className="learn-more-btn">
                    EXPLORE SERVICE →
                  </Link>
                </div>
              </SwiperSlide>

            </Swiper>

          </div>

        </motion.div>

      </section>

      {/* SECTION 4: who we are */}
      <section className="who-wrapper py-5 container" style={{ backgroundColor: '#ece7f4' }}>
        <motion.div
          className="who-container"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
        >

          {/* LEFT IMAGE */}
          <motion.div className="who-image-box my-lg-0 my-4" variants={imageAnim}>
            <img
              src="/images/who_we_are.png"
              alt="Who We Are"
              className="who-main-image"
            />
          </motion.div>

          {/* RIGHT CONTENT */}
          <motion.div className="who-content my-lg-0 my-4" variants={contentAnim}>

            <motion.h2 className="testmonial-badge" variants={itemAnim} style={{ display: 'inline-block' }}>
              WHO WE ARE
            </motion.h2>

            <motion.h2 variants={itemAnim}>
              SHAPING FUTURES WITH <span> EXPERT IT SOLUTIONS</span>
            </motion.h2>

            <motion.p variants={itemAnim}>
              Fortune Cloud Solutions is a dynamic IT development and staffing company dedicated to bridging the gap between talent and opportunity. Founded, we specialize in connecting skilled professionals with organizations, providing tailored staffing solutions, and delivering industry-relevant training programs.
            </motion.p>

            <motion.p variants={itemAnim}>
              Our mission is to empower individuals and businesses to achieve their highest potential through exceptional service, innovative solutions, and lasting partnerships. At Future Cloud Solutions, we are committed to driving success in the ever-evolving IT landscape
            </motion.p>

            {/* PROGRESS 1 */}
            <motion.div className="progress-item" variants={itemAnim}>
              <div className="progress-label">
                <span>IT CONSULTING</span>
                <span>92%</span>
              </div>
              <div className="progress-bar bg-secondary">
                <motion.div
                  variants={progressAnim("92%")}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                />
              </div>
            </motion.div>

            {/* PROGRESS 2 */}
            <motion.div className="progress-item" variants={itemAnim}>
              <div className="progress-label">
                <span>CAREER TRAINING</span>
                <span>90%</span>
              </div>
              <div className="progress-bar bg-secondary">
                <motion.div
                  variants={progressAnim("90%")}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                />
              </div>
            </motion.div>

            <Link to="/about">
              <motion.button className="discover-btn" variants={itemAnim}>
                DISCOVER MORE →
              </motion.button>
            </Link>

          </motion.div>

        </motion.div>
      </section>

      <>
        <ServicesSection />
        <Newsection />
        <Testimonials />
      </>
    </main>
  );
};

export default Hero;